var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileLock = function SvgIconFileLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2A1.75 1.75 0 0 0 3.5 3.75v7.875a1 1 0 1 0 2 0V4h7.375v4.625a1 1 0 0 0 1 1H18.5V20h-2.375a1 1 0 1 0 0 2h2.625a1.75 1.75 0 0 0 1.75-1.75v-12a1 1 0 0 0-.293-.707l-5.25-5.25A1 1 0 0 0 14.25 2zm9.625 3.04v2.585h2.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 17.25a1 1 0 0 1 1-1h.5v-.5a2.875 2.875 0 1 1 5.75 0v.5h.5a1 1 0 0 1 1 1v4.125a1 1 0 0 1-1 1H5.25a1 1 0 0 1-1-1zm5.25-1v-.5a.875.875 0 1 0-1.75 0v.5zm1.5 2v2.125H6.25V18.25z"
  }))));
};
export default SvgIconFileLock;